<template>
  <div class="allocation-of-resources-table">
    <div class="allocation-of-resources-table-header">
      <InputLabel value="Allocation of Resources" font-size="22"></InputLabel>
    </div>
    <el-table
      class="allocation-table"
      :data="tableData"
      empty-text="No Data Available"
      header-cell-class-name="table-header-dark"
      :cell-class-name="tableCellClassName">
      <el-table-column
        label="ORG ID"
        show-overflow-tooltip
        width="350">
        <template slot-scope="scope">
          {{ getOrgDisplay(scope) }}
        </template>
      </el-table-column>
      <el-table-column
        label="A"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="showValue(scope.row.allocationA, scope.$index)">
            {{scope.row.allocationA | currency}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="A1"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="showValue(scope.row.allocationA1, scope.$index)">
            {{scope.row.allocationA1 | currency}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="BC"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="showValue(scope.row.allocationBC, scope.$index)">
            {{scope.row.allocationBC | currency}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="F"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="showValue(scope.row.allocationF, scope.$index)">
            {{scope.row.allocationF | currency}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="T"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="showValue(scope.row.allocationT, scope.$index)">
            {{scope.row.allocationT | currency}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Total"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.allocationTotal | currency}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import InputLabel from '../misc/InputLabel.vue';

export default {
  name: 'AllocationOfResourcesTable',
  components: {
    InputLabel,
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tableColumns: ['orgId', 'allocationA', 'allocationA1', 'allocationBC', 'allocationF', 'allocationT', 'allocationTotal'],
    };
  },
  methods: {
    tableCellClassName({
      // eslint-disable-next-line no-unused-vars
      row, column, rowIndex, columnIndex,
    }) {
      const className = ['allocation-cell'];
      if (columnIndex !== 0
          && columnIndex !== this.tableColumns.length - 1
          && rowIndex < this.tableData.length - 1
          && this.tableData[rowIndex][this.tableColumns[columnIndex]] === 0) {
        className.push('empty-cell');
      }
      if (columnIndex === 0
        || columnIndex === this.tableColumns.length - 1
        || rowIndex >= this.tableData.length - 1) {
        className.push('bold-cell');
      }
      if (rowIndex >= this.tableData.length - 1) {
        className.push('black-text-cell');
      }
      return className.join(' ');
    },
    getOrgDisplay(scope) {
      const { orgId } = scope.row;
      return scope.row.orgName ? `${orgId}: ${scope.row.orgName}` : orgId;
    },
    showValue(val, index) {
      return (val && val !== 0) || index === this.tableData.length - 1;
    },
  },
};
</script>

<style scoped lang="scss">
  .allocation-of-resources-table {
    .allocation-of-resources-table-header {
      height: 40px;
      margin-bottom: 10px;
      .allocation-of-resources-table-info {
        margin-left: 5px;
        font-size: 16px;
      }
    }
  }
</style>
